var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HelpBox',{attrs:{"backgroundUrl":_vm.backgroundUrl},on:{"click":_vm.askCommunityForHelp},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('span',[_vm._v(" Ask for help"),_c('br'),_vm._v("from the community ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }